<script setup>
import {
  PopoverContent as PopoverContentPrimitive,
  PopoverPortal,
} from 'reka-ui'

import { cn } from '@/lib/utils'

import { POPOVER_CONTENT_CLASS } from '.'

var props = defineProps({
  class: { type: null, required: false, default: null },
  sideOffset: { type: Number, required: false, default: 4 },
  zIndex: { type: [Number, String], required: false, default: 1200 },
})
</script>

<template>
  <PopoverPortal>
    <PopoverContentPrimitive v-bind="$attrs" as-child :side-offset="sideOffset">
      <div
        :class="cn(POPOVER_CONTENT_CLASS, props.class)"
        :style="{ zIndex: String(props.zIndex) }"
      >
        <slot />
      </div>
    </PopoverContentPrimitive>
  </PopoverPortal>
</template>
